module.exports = __webpack_public_path__ + "static/media/badge_ENG_Appstore.9210db5e.png";